export const MAX_FILE_SIZE_LABEL = "10MB";
export const MAX_FILE_SIZE = 10485760;
